import { render, staticRenderFns } from "./BaseColors.vue?vue&type=template&id=38fd022f&scoped=true&"
import script from "./BaseColors.vue?vue&type=script&lang=ts&"
export * from "./BaseColors.vue?vue&type=script&lang=ts&"
import style0 from "./BaseColors.vue?vue&type=style&index=0&id=38fd022f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd022f",
  null
  
)

export default component.exports